import { EmptyState } from "@design-system/EmptyState/EmptyState";

interface Props {
    searchFilter: string | undefined;
}

export const CoaMappingEmptyState = ({ searchFilter }: Props) => (
    <EmptyState
        header={
            searchFilter
                ? "No accounts match your search"
                : "No accounts imported yet"
        }
    />
);
